import { Link } from "react-router-dom";

import AuthLayout from "../layout/AuthLayout";
import JobSeekerRegistrationForm from "./JobSeekerRegistrationForm";

function RegisterScreen() {
	return (
		<AuthLayout>
			<Link to="/" className="mb-10 block md:hidden">
				<img src="/images/logo.png" alt="DProz Logo" className="mx-auto w-[140px]" />
			</Link>
			<header className="mb-8">
				<h2 className="font-plus-jakarta text-2xl font-bold text-gray-900">Your dream job starts here</h2>
				<p className="mt-2 text-[15px] leading-relaxed text-gray-600">Create a free account in under a minute.</p>
			</header>
			<JobSeekerRegistrationForm />
		</AuthLayout>
	);
}

export default RegisterScreen;
